<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <el-form-item>
          <el-input
            v-model="formInline.positionName"
            placeholder="搜索职位"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="other-search" style="width: 100px" @click="addJob()">
            <i class="iconfont icon-yaoqing"></i
            ><span style="font-size: 14px">发布职位</span>
          </div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-progress">
        <div class="progress-list" v-for="item in jobList" :key="item.jobId">
          <div class="progress-list-title">
            {{ item.clientCompanyName }} | {{ item.publishTime }}
          </div>
          <div class="progress-list-job">
            <span>{{ item.positionName }}</span>
            <span v-if="item.isFace != 1"
              >￥ {{ item.salaryBegin }}-{{ item.salaryEnd }}</span
            >
            <span v-if="item.isFace == 1">面议</span>
          </div>
          <div class="progress-list-tags">
            <span>{{ item.shipTypeName }}</span>
            <span>{{ item.recuritShipTon }}吨</span>
            <span>{{ item.workingYearEnd }}年航海经验</span>
          </div>
          <el-divider class="progress-list-divider"></el-divider>
          <div class="progress-list-footer">
            <div class="progress-footer-left">
              <span style="cursor: pointer" @click="gotoJob(item)"
                >已投递({{ item.applyJobNum }})</span
              >
              <!-- <span>已面试(6)</span>
              <span>已任职(1)</span> -->
            </div>
            <div class="progress-footer-right">
              <span @click="viewDetail(item)"
                ><i class="iconfont icon-chakan" style="color: #4e8aff"></i
                >查看</span
              >
              <span @click="progressList(item)">
                <i class="iconfont icon-icon-" style="color: #f85e78"></i>
                上线</span
              >
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectCompanyJobList } from "@/apis/index";

export default {
  data() {
    return {
      formInline: {},
      tableData: [
        {
          date1: "张玉峰",
          date2: "男",
          date3: "420621197908262732",
          date4: "15365321563",
          date5: "60%",
          date6: "未加入",
          date7: "2023-8-19",
        },
      ],
      currentPage1: 1,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      pageNo: 1,
      total: 0,
      jobList: [],
    };
  },
  mounted() {
    this.selectCompanyJobLists();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.selectCompanyJobLists();
    },
    handleOpen() {},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    async selectCompanyJobLists() {
      let companyId = sessionStorage.getItem("companyId");
      let res = await selectCompanyJobList({
        pageSize: "10",
        pageNo: this.pageNo,
        companyId: companyId,
        status: "2",
        positionName: this.formInline.positionName,
      });
      this.jobList = res.data.resultList;
      this.total = res.data.rowCount;
      // console.log(res);
    },
    comDetail() {},
    viewDetail(item) {
      this.$router.push({
        name: "addCrewJob2",
        params: { name: "发布职位", jobId: item.jobId, editVisible: true },
      });
    },
    addJob() {
      this.$router.push({ name: "addCrewJob2", params: { name: "发布职位" } });
    },
    gotoJob(item) {
      this.$router.push({ name: "crewPass", params: { jobId: item.jobId } });
    },
    progressList(item) {
      this.$router.push({
        name: "addCrewJob2",
        params: {
          name: "发布职位",
          jobId: item.jobId,
          editVisible: true,
          progressVisible: true,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.5em;
  height: 0.5em;
}

/* 隐藏滚动条轨道 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 隐藏滚动条滑块 */
::-webkit-scrollbar-thumb {
  background-color: transparent;
}
</style>
